import React, { useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import config from 'constants/config'
import Pane from 'components/Common/Pane'
import TrustPilotSection from 'components/Common/TrustReviewSection/TrustPilotSection'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

const TrustPilotContainer = styled(Pane)`
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(20)} ${rem(24)};
`

const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  contain: inline-size;
`

interface Props {
  className?: string
}

function OfferPageTrustPilot({ className }: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const startedLoggedInRef = useRef(isLoggedIn)
  const experiment = useAppSelector(
    state => state.optimizely.optimizelyExperiments[OptimizelyExperiments.croTrustpilotReviewFeedInOfferPage],
  )
  const experimentDecision = experiment?.variationKey
  const isExperimentEnabled = getOptimizelyEnabledDecision(experimentDecision)
  const isEligible = !startedLoggedInRef.current
  const isInExperiment = isEligible && experimentDecision !== undefined
  const shouldShow = isEligible && isExperimentEnabled

  const isLuxuryEscapes = config.BRAND === 'luxuryescapes'

  useOptimizelyExperiment(
    OptimizelyExperiments.croTrustpilotReviewFeedInOfferPage,
    isLuxuryEscapes && isEligible,
  )

  if (!isLuxuryEscapes) {
    return null
  }

  if (!isInExperiment) {
    return null
  }

  if (!shouldShow) {
    return null
  }

  return (
    <TrustPilotContainer className={className}>
      <CarouselWrapper>
        <TrustPilotSection />
      </CarouselWrapper>
    </TrustPilotContainer>
  )
}

export default React.memo(OfferPageTrustPilot)
